
<page-layout :title="title">
    <keep-alive v-if="multipage">
      <router-view ref="page"/>
    </keep-alive>
    <router-view ref="page" v-else/>
</page-layout>
